import { FC, useContext, useMemo } from 'react';
import { HomePageContext } from 'src/constructors/pageConstructors/HomePageConstructor';
import WinReplaysWidget from './WinReplaysWidget';

export type Props = {
  settings: any;
  type: string;
};

export const WinReplays: FC<Props> = ({ settings, type }) => {
  const homePageContext = useContext(HomePageContext);

  const winReplaysData = useMemo(() => {
    if (type === 'home') {
      return homePageContext?.pageFields?.gameReplayGroup?.[0]?.relation;
    }
    return null;
  }, [homePageContext, settings?.data?.pageContext, type]);

  return <WinReplaysWidget winReplaysData={winReplaysData} />;
};

export default WinReplays;
